import React from "react";
import {
  RootComponentListPageContent,
  RootComponentListPageStateProvider,
} from ".";

export const RootComponentListPage = () => {
  return (
    <RootComponentListPageStateProvider>
      <RootComponentListPageContent></RootComponentListPageContent>
    </RootComponentListPageStateProvider>
  );
};
